exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".children-7b6c22b0{display:inline-block;padding:20px}.empty-aa9c5f69{height:100px;text-align:center}.contents-1c4de7a2{display:inline-block;float:left}.contents-1c4de7a2 img{max-width:100%}.actions-43363a32{display:flex;justify-content:center}.actions-43363a32>a:first-child{padding-right:20px}\n", ""]);

// Exports
exports.locals = {
	"children": "children-7b6c22b0",
	"empty": "empty-aa9c5f69",
	"contents": "contents-1c4de7a2",
	"actions": "actions-43363a32"
};